import React from 'react';
import { Grid } from '@mui/material';
import { GetProjectSettingsResponse, Projects } from 'src/model/api/v2/data-contracts';
import { useSetMeasurementSystemMutation, useSetPlannerIconSetMutation } from 'src/api/v1/project-settings-ApiSlice';
import { SettingsSection } from 'src/pages/ProjectSettingsPage/components/SettingsSection';
import { SettingsSelect } from 'src/pages/ProjectSettingsPage/components/SettingsSelect';
import { useSaveFeedback } from 'src/pages/ProjectSettingsPage/useSaveFeedback';
import { ts } from 'src/utils/translate';

type Props = {
    projectId: number;
    project: Projects;
    settings: GetProjectSettingsResponse;
    canEdit: boolean;
};

export const MiscSettingsSection = ({ projectId, project, settings, canEdit }: Props) => {
    const [setMeasurementSystem] = useSetMeasurementSystemMutation();
    const [setPlannerIconSet] = useSetPlannerIconSetMutation();
    const { showSaveSuccess, showSaveError } = useSaveFeedback();

    const handleMeasurementSystemChange = (measurementId: number) => {
        setMeasurementSystem({ projectId, measurementId })
            .unwrap()
            .then(showSaveSuccess)
            .catch(showSaveError);
    };

    const handleIconSetChange = (plannerIconSetId: number) => {
        setPlannerIconSet({ projectId, plannerIconSetId })
            .unwrap()
            .then(showSaveSuccess)
            .catch(showSaveError);
    };

    return (
        <SettingsSection title={ts('project_settings_misc_title', 'Miscellaneous settings')}>
            <Grid container spacing={3}>
                <Grid size={{ xs: 12, md: 6 }}>
                    <SettingsSelect
                        id="measurement-system"
                        label={ts('project_settings_measurement_system', 'Measurement system')}
                        value={project.system_of_measurement_id}
                        options={settings.options.measurement_systems}
                        disabled={!canEdit}
                        onChange={handleMeasurementSystemChange}
                    />
                </Grid>
                <Grid size={{ xs: 12, md: 6 }}>
                    <SettingsSelect
                        id="icon-set"
                        label={ts('project_settings_icon_set', 'Icon set')}
                        value={project.planner_icon_set_id}
                        options={settings.options.icon_sets}
                        disabled={!canEdit}
                        onChange={handleIconSetChange}
                    />
                </Grid>
            </Grid>
        </SettingsSection>
    );
};
